// jQuery_T4NT(document).ready(function($) {

//      /**
//      *  Variant selection changed
//      *  data-variant-toggle="{{ variant.id }}"
//      */
// 	   $( document ).on( "variant:changed", function( evt ) {
// 	     // console.log( evt.currentVariant );
// 	     // $('[data-variant-toggle]').hide(0);
// 	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
// 	   });

//      window.addEventListener("load", function() {
//         this.document.querySelector('.custom-search-bar .boost-sd__search-widget-init-input')
//           .placeholder = 'Search SKU or Product Name';
//         this.document.querySelector('.t4s-search-header__form .boost-sd__search-widget-init-input')
//           .placeholder = 'Search for products';
//      },{once:true});
// });

// Highlight newsletter section
const subscribeBtn = document.querySelector('.subscribe-banner .t4s-btn');

if (subscribeBtn) {
  const link = subscribeBtn.getAttribute('href');

  subscribeBtn.addEventListener('click', function(e) {
    e.preventDefault();

    if (link && link.startsWith('#')) {
      const target = document.querySelector(link);
      const newsletter = document.querySelector('#shopify-section-footer .t4s-newsletter-parent .t4s-newsletter__inner');
      const emailInput = newsletter.querySelector('input[type="email"]');

      target.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        newsletter.style.borderColor = '#c0272d';
      }, 300);
      setTimeout(() => {
        newsletter.style.borderColor = '#ffffff';
      }, 1500);
      emailInput.focus({ preventScroll: true });
    }
  })
}